import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('v-breadcrumbs-divider', 'li')
